import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle2, ArrowRight } from 'lucide-react';

export function NextStepPrompt({ 
  title = "What's next?",
  message,
  primaryAction,
  secondaryAction,
  onPrimaryClick,
  onSecondaryClick,
  icon = CheckCircle2
}) {
  const Icon = icon;

  return (
    <Card className="border-green-200 bg-green-50 dark:bg-green-950 dark:border-green-800">
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className="rounded-full bg-green-100 dark:bg-green-900 p-2">
            <Icon className="h-5 w-5 text-green-600 dark:text-green-400" />
          </div>
          <div className="flex-1 space-y-3">
            <div>
              <h3 className="font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
              {message && <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">{message}</p>}
            </div>
            <div className="flex gap-2">
              {primaryAction && onPrimaryClick && (
                <Button onClick={onPrimaryClick} size="sm" data-testid="next-step-primary">
                  {primaryAction}
                  <ArrowRight className="h-4 w-4 ml-1" />
                </Button>
              )}
              {secondaryAction && onSecondaryClick && (
                <Button onClick={onSecondaryClick} variant="outline" size="sm" data-testid="next-step-secondary">
                  {secondaryAction}
                </Button>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
